export default __webpack_public_path__ + "static/dinnerforone-c59dcdd14ae6894e0b836ef2bb8c6a81.png";